import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import GroupFormModal from '../../components/organizations/GroupFormModal/index.jsx';
import {
  retrieveOrgGroups,
  selectOrgGroups,
  selectRetrieveGroupsState,
} from '../../modules/orgGroups.js';

const mapStateToProps = (state) => ({
  groups: selectOrgGroups(state),
  retrieveSuccess: selectRetrieveGroupsState(state).success,
});

const mapDispatchToProps = { retrieveOrgGroups };

function GroupFormContainer(props) {
  const {
    retrieveSuccess,
    groups,
    showFormModal,
    onHideFormModal,
    retrieveOrgGroups,
    onSubmitSuccess,
  } = props;

  useEffect(() => {
    !(retrieveSuccess || groups || groups.length) &&
      !retrieveOrgGroups({ active: true });
  }, []);

  return (
    retrieveSuccess && (
      <GroupFormModal
        onSubmitSuccess={onSubmitSuccess}
        onHide={onHideFormModal}
        show={showFormModal}
        groups={groups}
      />
    )
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupFormContainer);
